import { LoadableRoute } from 'routes/utils/loadable';

export const SharedListContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "SharedList" */ './SharedList'),
});
